import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
} from 'api';
import { AxiosResponse } from 'axios';
import { BaseResponse } from 'features/auth';
import { NotificationListResponse, ReadNotificationDTO } from 'features/users';
import { UnreadNotificationCount } from 'types';

type Noresult = {
   id?:number
};
export const NotificatoinsApiService = () => {
  const getNotificationList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<NotificationListResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/NotificationList`,
      params,
    });

    return response.data;
  };

  const readNotification = async (
      payload: ReadNotificationDTO,
      callConfig?: Partial<ApiClientConfig>,
    ) => {  
      //const { userId, ...data } = payload;
      const data = payload ;
      const response = await apiClient<BaseResponse<Noresult>>({
        ...callConfig,
        endpoint: `AdminWeighbridge/ReadNotification`,
        method: 'PATCH',
        data,
      });
      
      return response.data.rs;
    };

     const getUnreadNotification = async (id: string, callConfig?: Partial<ApiClientConfig>): Promise<BaseResponse<UnreadNotificationCount>> => {
        const response: AxiosResponse<BaseResponse<UnreadNotificationCount>> = await apiClient<BaseResponse<UnreadNotificationCount>>({
          ...callConfig,
          endpoint: `/AdminWeighbridge/UnReadNotificationCount/${id}`,
        });
                
        return {
          res: response.data.res,
          rs: response.status,
        };
      };
    
     
      

  return {
    getNotificationList,
    readNotification,
    getUnreadNotification
  };
};



